<div class="row">
  <div class="col-12">
    <div class="content-header">Batch Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <!-- <div class="card-header">
					<h4 class="card-title">Basic</h4>
				</div> -->
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="batchForm">
                  <fieldset class="form-group">
                    <label for="name"> Name</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="name"
                      id="name"
                      placeholder="Enter Name"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.name.invalid,
                        'is-valid': batchFormSubmitted && !rf.name.invalid
                      }"
                      required
                      #name
                    />
                    <div
                      *ngIf="
                        rf.name.touched &&
                        (rf.name.invalid || rf.name.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Name is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label> Course</label>
                    <ng-select
                      [items]="courselist"
                      bindLabel="title"
                      bindValue="_id"
                      [closeOnSelect]="false"
                      placeholder="Select Course"
                      [(ngModel)]="selectedValue"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getCourseById($event)"
                    >
                    </ng-select>
                  </fieldset>
                  <!-- <fieldset class="form-group">
                    <label for="noOfSeats">Number Of Seats</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="noOfSeats"
                      id="noOfSeats"
                      placeholder="Enter Number Of Seats"
                      [ngClass]="{
                        'is-invalid':
                          batchFormSubmitted && rf.noOfSeats.invalid,
                        'is-valid': batchFormSubmitted && !rf.noOfSeats.invalid
                      }"
                      required
                      #noOfSeats
                    />
                    <div
                      *ngIf="
                        rf.noOfSeats.touched &&
                        (rf.noOfSeats.invalid || rf.noOfSeats.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Number Of
                      Seats is required
                    </div>
                  </fieldset> -->

                  <!-- <fieldset>
                    <label for="batchType">Batch Type</label>
                    <ul class="list-unstyled mb-0">
                      <li class="d-inline-block mr-2">
                        <div class="radio">
                          <input
                            type="radio"
                            value="offline"
                            name="basic-radio-1"
                            [(ngModel)]="selectValue"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="change($event)"
                            id="offline"
                            checked
                          />
                          <label for="offline">offline</label>
                        </div>
                      </li>
                      <li class="d-inline-block mr-2">
                        <div class="radio">
                          <input
                            type="radio"
                            value="online"
                            [(ngModel)]="selectValue"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="change($event)"
                            name="basic-radio-1"
                            id="online"
                          />
                          <label for="online">online</label>
                        </div>
                      </li>
                    </ul>
                  </fieldset> -->
                  <fieldset class="form-group">
                    <label for="start_date"> Start Date</label>
                    <input
                      type="date"
                      class="form-control"
                      formControlName="start_date"
                      id="start_date"
                      placeholder="Enter start_date"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.start_date.invalid,
                        'is-valid': batchFormSubmitted && !rf.start_date.invalid
                      }"
                      required
                      #start_date
                    />
                    <div
                      *ngIf="
                        rf.start_date.touched &&
                        (rf.start_date.invalid || rf.start_date.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Start Date is
                      required
                    </div>
                  </fieldset>

                  <fieldset class="form-group">
                    <label for="start_time">Start Time</label>
                    <input
                      type="time"
                      class="form-control"
                      formControlName="start_time"
                      id="name"
                      placeholder="Enter Start Time"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.start_time.invalid,
                        'is-valid': batchFormSubmitted && !rf.start_time.invalid
                      }"
                      required
                      #start_time
                    />
                
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="end_time">End Time</label>
                    <input
                      type="time"
                      class="form-control"
                      formControlName="end_time"
                      id="name"
                      placeholder="Enter End Time"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.end_time.invalid,
                        'is-valid': batchFormSubmitted && !rf.end_time.invalid
                      }"
                      required
                      #end_time
                    />
                 
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="description">Description</label>
                    <textarea
                      formControlName="description"
                      id="hidden-label-form-6"
                      rows="1"
                      class="form-control"
                      name="comment2"
                      placeholder="Enter description"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.description.invalid,
                        'is-valid': batchFormSubmitted && !rf.description.invalid
                      }"
                      required
                      #description
                    ></textarea>
                  
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="days">Days</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="days"
                      id="name"
                      placeholder="Enter days"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.days.invalid,
                        'is-valid': batchFormSubmitted && !rf.days.invalid
                      }"
                      required
                      #days
                    />
                 
                  </fieldset>
                
                  
                  <!-- <fieldset class="form-group" *ngIf="isOffline">
                    <label for="joiningLink">Joining Link</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="joiningLink"
                      id="joiningLink"
                      placeholder="Enter Joining Link"
                      [ngClass]="{
                        'is-invalid':
                          batchFormSubmitted && rf.joiningLink.invalid,
                        'is-valid':
                          batchFormSubmitted && !rf.joiningLink.invalid
                      }"
                      required
                      #joiningLink
                    />
                    <div
                      *ngIf="
                        rf.joiningLink.touched &&
                        (rf.joiningLink.invalid ||
                          rf.joiningLink.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Joining Link
                      is required
                    </div>
                  </fieldset> -->
                </form>
              </div>
              <div class="col-md-6">
                <form [formGroup]="batchForm">
                  <fieldset class="form-group">
                    <label for="instructor">Instructor</label>
                      <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Select Instructor"
                          [(ngModel)]="selected_user" [ngModelOptions]="{ standalone: true }"
                          (change)="getSelectUserId($event)" #huntingBy="ngModel">
                      </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="">Mode</label>
                    <ng-select [items]="learningList" bindLabel="name" bindValue="_id" placeholder="Select Learning Mode"
                      [(ngModel)]="learningMode" [ngModelOptions]="{ standalone: true }" (change)="getLearningId($event)">
                    </ng-select>
                  </fieldset>
                  <!-- <fieldset class="form-group">
                    <label for="learning_mode">Learning Mode</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="learning_mode"
                      id="name"
                      placeholder="Enter Learning Mode"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.learning_mode.invalid,
                        'is-valid': batchFormSubmitted && !rf.learning_mode.invalid
                      }"
                      required
                      #learning_mode />
                  </fieldset> -->
                  <fieldset class="form-group">
                    <label for="joining_link"> Joining Link</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="joining_link"
                      id="name"
                      placeholder="Enter Learning Mode"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.joining_link.invalid,
                        'is-valid': batchFormSubmitted && !rf.joining_link.invalid
                      }"
                      required
                      #joining_link />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="max_student"> Max Student</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="max_student"
                      id="name"
                      placeholder="Enter Maximum Students"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.max_student.invalid,
                        'is-valid': batchFormSubmitted && !rf.max_student.invalid
                      }"
                      required
                      #max_student />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="specailnotes">Specail Notes</label>
                    <textarea
                      formControlName="specailnotes"
                      id="hidden-label-form-6"
                      rows="1"
                      class="form-control"
                      name="comment2"
                      placeholder="Enter Specail Notes"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.specailnotes.invalid,
                        'is-valid': batchFormSubmitted && !rf.specailnotes.invalid
                      }"
                      required  
                    ></textarea>
                  
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="notes">Notes</label>
                    <textarea
                      formControlName="notes"
                      id="hidden-label-form-6"
                      rows="1"
                      class="form-control"
                      name="comment2"
                      placeholder="Enter notes"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.notes.invalid,
                        'is-valid': batchFormSubmitted && !rf.notes.invalid
                      }"
                      required
                      #notes
                    ></textarea>
                  
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="admin_notes">Admin Notes</label>
                    <textarea
                      formControlName="admin_notes"
                      id="hidden-label-form-6"
                      rows="1"
                      class="form-control"
                      name="comment2"
                      placeholder="Enter admin_notes"
                      [ngClass]="{
                        'is-invalid': batchFormSubmitted && rf.admin_notes.invalid,
                        'is-valid': batchFormSubmitted && !rf.admin_notes.invalid
                      }"
                      required
                      #admin_notes
                    ></textarea>
                  
                  </fieldset>


                  <div
                    class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                  >
                    <button
                      type="submit"
                      class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                      [disabled]="
                        name.value.length === 0 
                      "
                      (click)="submitCourse()"
                    >
                      Submit
                    </button>
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      (click)="back()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
